import { Box, Grid, Typography, Card, useTheme } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { DashboardFiltersDto, UpcomingEventsData, PeriodType } from "../../../types/dashboard";
import { DashboardSummary } from "../Components/DashboardSummary";
import { MetricsByEvent } from "../Components/MetricsByEvent";
import { CEOEventsList } from "../Components/CEOEventsList";
import { useDashboard } from "../../../contexts/DashboardContext";

interface CEODashboardProps {
  filters: DashboardFiltersDto;
}

export const CEODashboard = ({ filters }: CEODashboardProps) => {
  const theme = useTheme();
  const { upcomingEvents, loading } = useDashboard();

  // Garantir que os filtros incluam o campo includeExtraFields
  const enhancedFilters = useMemo(() => {
    return {
      ...filters,
      includeExtraFields: true // Sempre incluir campos extras para o dashboard CEO
    };
  }, [filters]);

  return (
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DashboardSummary />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <MetricsByEvent
                title="Próximos eventos por faturamento"
                subtitle={upcomingEvents?.periodLabel}
                events={upcomingEvents?.byBilling || []}
                metricType="billing"
                loading={loading}
                color="#5b45d4" // Faturamento
                maxItems={100} // Exibir até 100 itens
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <MetricsByEvent
                title="Próximos eventos por receita"
                subtitle={upcomingEvents?.periodLabel}
                events={upcomingEvents?.byRevenue || []}
                metricType="revenue"
                loading={loading}
                color="#1e9e6a" // Receita
                maxItems={100} // Exibir até 100 itens
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <MetricsByEvent
                title="Próximos eventos por público"
                subtitle={upcomingEvents?.periodLabel}
                events={upcomingEvents?.byAudience || []}
                metricType="audience"
                loading={loading}
                color="#F4799F" // Rosa
                maxItems={100} // Exibir até 100 itens
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <CEOEventsList />
        </Grid>
      </Grid>
    </Box>
  );
};
